import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../lib/shadcn/tooltip'
import { Chip } from '../interviews/Chip'

// A quiet, non-clickable indicator for a row that has no reconcile proposal of
// its own. Critically this is NOT a disabled Reconcile button: a greyed-out
// button reads as "a fix exists but is unavailable", which is exactly the wrong
// message. In a duplicate slot the proposal lives on the OTHER driver's row, so
// offering anything action-shaped here risks reconciling the supported driver
// onto the wrong car.
export function NoProposalChip({ tooltip }: { tooltip: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex cursor-default">
            <Chip tone="neutral">No proposal</Chip>
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
